// /assets/js/gsap-boot.js
(function () {
  if (!window.gsap) {
    console.error("[GSAP Boot] gsap not found on window. Check script order.");
    return;
  }
  if (window.__gsapBoot) return; // prevent double-run on SPA/nav

  // Register plugins globally
  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
  if (window.ScrollSmoother) gsap.registerPlugin(ScrollSmoother);

  // Sensible defaults
  if (window.ScrollTrigger) {
    ScrollTrigger.defaults({
      invalidateOnRefresh: true,
      // markers: true, // uncomment only for debugging
    });

    // Refresh once everything has computed sizes
    window.addEventListener("load", () => ScrollTrigger.refresh());
  }

  // Optional: create ScrollSmoother if the wrapper/content exist
  const wrapper = document.querySelector("#smooth-wrapper");
  const content = document.querySelector("#smooth-content");
  if (window.ScrollSmoother && wrapper && content) {
    window.__smoother = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 1.2,
      effects: true, // enables data-speed / data-lag
    });
  }

  window.__gsapBoot = true;
})();
